(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor(){ super(); }

  connectedCallback(){
    this.section = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.setHeaderHeight = this.setHeaderHeight.bind(this);
    this.onScrollHandler = this.onScroll.bind(this);
    this.onMutations = this.onMutations.bind(this);

    /* Init CSS vars */
    this.setHeaderHeight();

    /* Keep vars fresh */
    this.resizeObs = new ResizeObserver(this.setHeaderHeight);
    this.resizeObs.observe(this.section);
    this.mql = window.matchMedia('(max-width: 990px)');
    this.mql.addEventListener('change', this.setHeaderHeight);

    if (this.headerIsAlwaysSticky) this.section.classList.add('shopify-section-header-sticky');

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    /* Observe DOM to know when menu/search opens/closes */
    this.mo = new MutationObserver(this.onMutations);
    this.mo.observe(document.body, { attributes:true, childList:true, subtree:true, attributeFilter:['open','aria-expanded','class'] });
    this.syncOverlayPin();

    /* Measure threshold once and apply initial state */
    this.createObserver();
    this.headerBounds = this.section.getBoundingClientRect();
    requestAnimationFrame(() => this.onScroll());
  }

  disconnectedCallback(){
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    if (this.resizeObs) this.resizeObs.disconnect();
    if (this.mo) this.mo.disconnect();
    if (this.mql) this.mql.removeEventListener?.('change', this.setHeaderHeight);
  }

  setHeaderHeight(){
    if (!this.section) return;
    document.documentElement.style.setProperty('--header-height', `${this.section.offsetHeight}px`);
  }

  createObserver(){
    const ob = new IntersectionObserver((entries, o)=>{
      this.headerBounds = entries[0].intersectionRect;
      o.disconnect();
    });
    ob.observe(this.section);
  }

  /* ---------- overlay helpers ---------- */
  isMenuOpen(){
    return !!(this.section?.querySelector('header-drawer details[open]') ||
              this.section?.querySelector('header-drawer .menu-drawer__button[aria-expanded="true"]'));
  }
  isSearchOpen(){
    return !!(this.section?.querySelector('.header__search details[open]'));
  }
  isOverlayOpen(){ return this.isMenuOpen() || this.isSearchOpen(); }

  syncOverlayPin(){
  const megaOpen = !!this.section.querySelector('.vld-nav__item.is-open');
  const menuOpen = this.isMenuOpen() || megaOpen;
  const searchOpen = this.isSearchOpen();

  this.section.classList.toggle('section-header--overlay-open', menuOpen || searchOpen);

  document.documentElement.toggleAttribute('data-menu-open', menuOpen);
  document.documentElement.toggleAttribute('data-search-open', searchOpen);
}


  onMutations(){
    // Any toggle anywhere -> re-evaluate
    this.syncOverlayPin();
  }

  /* Close helpers */
  closeMenuDrawer(){
    const scope = this.section?.querySelector('header-drawer');
    const details = scope?.querySelector('details[open]');
    if (details){ details.removeAttribute('open'); }
    const btn = scope?.querySelector('.menu-drawer__button[aria-expanded="true"]');
    if (btn){ btn.click(); }
    const closeBtn = scope?.querySelector('.menu-drawer__close, .menu-drawer__close-button');
    if (closeBtn){ closeBtn.click(); }
    const drawer = scope?.querySelector('.menu-drawer.is-open, .menu-drawer[open]');
    if (drawer){ drawer.classList.remove('is-open'); }
  }
  closeSearchModal(){
    const openSearch = this.section?.querySelector('.header__search details[open]');
    if (openSearch) openSearch.removeAttribute('open');
    const modal = this.section?.querySelector('details-modal');
    if (modal?.close) modal.close(false);
  }

  setHeaderHiddenFlag(hidden){
    if (hidden) document.documentElement.setAttribute('data-header-hidden','1');
    else document.documentElement.removeAttribute('data-header-hidden');
  }

  onScroll(){
    if (!this.headerBounds) return;

    const st = window.pageYOffset || document.documentElement.scrollTop;
    const goingDown = st > this.currentScrollTop + 2; // tiny threshold to avoid jitter
    const pastThreshold = st > this.headerBounds.bottom;

    if (this.section.classList.contains('section-header--overlay-open')){
  /* 🔒 Freeze header + mega completely */
  this.currentScrollTop = st;
  return;
}



    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // Normal hide/reveal after threshold
    if (st > this.currentScrollTop && pastThreshold){
      this.section.classList.add('scrolled-past-header');
      if (!this.headerIsAlwaysSticky){
        this.section.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');
        this.setHeaderHiddenFlag(true);
        this.closeMenuDrawer();
        this.closeSearchModal();
      }
    } else if (st < this.currentScrollTop && pastThreshold){
      this.section.classList.add('scrolled-past-header');
      if (!this.headerIsAlwaysSticky){
        this.section.classList.add('shopify-section-header-sticky','animate');
        this.section.classList.remove('shopify-section-header-hidden');
        this.setHeaderHiddenFlag(false);
      }
    } else if (st <= this.headerBounds.top){
      if (!this.headerIsAlwaysSticky){
        this.section.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate','scrolled-past-header');
        this.setHeaderHiddenFlag(false);
      }
    }

    this.currentScrollTop = st;
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
